const allroles = { data: [], loading: true };
export const GetAllScreens = (state = allroles, action) => {
  switch (action.type) {
    case "get_allscreens":
      return {
        data: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};
